import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';

const NewsLetter = () => {
  const logos = [
    { src: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1748784175/image_1705_zjk9oa.png', link: 'https://plofoundation.org/' },
    { src: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1748784350/image_1711_gfxdhn.png', link: 'https://www.nnfu.org.na/' },
    { src: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1748784276/image_1758_i9lydb.png', link: 'https://www.partnersforcare.org/ourprograms' },
    { src: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1748784351/image_1623_fwuqqw.png', link: 'https://4-bm.africa/' },
    {
      src: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744212807/image_1526_k5t6wh.png',
      link: 'https://www.myhustle.africa',
    },
    {
      src: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1748784175/image_1709_fftpry.png',
      link: 'https://mawlr.gov.na/ ',
    },
  ];

  return (
    <div className="px-4  md:pr-20 md:pl-[120px] md:pb-0 pb-2 ">
      <div className="w-full bg-[#2E453D]  rounded-b-[2px] md:rounded-b-[5px] flex md:pr-4  pr-2 items-center justify-between md:gap-8 gap-4  py-2 md:py-4 md:h-[90px]">
        <h1 className="text-white md:text-[24px] text-[6px] w-full leading-snug  h-[15px] md:h-[40px] rounded-[5px] pl-6 md:pl-10 ">
        Better Planning, Smarter Production, Market Access, and Sustainable Growth
        </h1>
        <a
    href="/argitech1"
          className="md:w-[300px] w-[125px] h-[15px] md:h-[50px] shadow-xl flex items-center justify-center rounded-[2px] md:rounded-[8px] font-bold text-[6px] md:text-[20px] text-white md:mb-0"
          style={{
            background: "linear-gradient(90deg, #FDBB26 25%, #152C24 53%)",
            boxShadow: "0px 4px 10px rgba(0,0,0,0.3)",
          }}
        >
          <span className="flex-1 text-center">Go To</span>
          <img
            src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1756410811/Expand_right_1_bpdsxb.png"
            alt="arrow"
            className="md:w-[23px] w-[12px] h-[14px] md:h-[21px] mr-1 md:mr-4"
          />
        </a>
          
      </div>
    </div>
  );
};

export default NewsLetter;
